import apiInstance from "./instance";


export const getDevUser = async () => {
    return await apiInstance.get("/devuser");
};

export const getCards = async () => {
    try {
        return await apiInstance.get("/cards");
    } catch (error) {
        console.error("Error fetching cards", error);
        return [];
    }
};

export const login = async () => {
    try {
        return await apiInstance.post("/login",{});
    } catch (error) {
        console.error("Error logging in", error);
        alert("Giriş yapılırken bir hata oluştu",JSON.stringify(error));
        return null;
    }
};

export const getMe = async () => {
    return await apiInstance.get('/me');
};

export const getSiweNonce = async () => {
    return await apiInstance.get('/siwe/nonce');
};

export const loginWithSiwe = async ({ message, signature, referrer } = {}) => {
    return await apiInstance.post('/login', { message, signature, referrer });
};

export const logoutSiwe = async () => {
    return await apiInstance.post('/siwe/logout', {});
};

export const getProducts = async (query) => {
    try {
        return await apiInstance.post(`/products`,{query});
    } catch (error) {
        console.error("Error fetching products", error);
        return [];
    }
};

export const getPreSales = async () => {
    try {
        return await apiInstance.get("/presales");
    } catch (error) {
        console.error("Error fetching pre-sales", error);
        return [];
    }
};

export const getDeck = async () => {
    return await apiInstance.get("/deck");
};

export const getAirDrop = async () => {
    return await apiInstance.get("/airdrop");
}
export const getTokens = async () => {
    return await apiInstance.get("/tokens");
}
export const getInAppTokens = async () => {
    return await apiInstance.get("/inapptokens");
}
export const getInventory = async () => {
    return await apiInstance.get("/inventory");
}

export const getLevels = async () => {
    return await apiInstance.get("/levels");
}
export const getTransactions = async () => {
    return await apiInstance.get("/transactions");
}
export const getWithdrawalsAndPresales = async () => {
    return await apiInstance.get("/withdrawalsAndPresales");
}
export const prosessInventoryItemUse = async (itemId) => {
    return await apiInstance.post(`/inventory/use/${itemId}`);
}
export const getTransactionStatus = async (invoiceId) => {
    return await apiInstance.get(`/transactions/${invoiceId}`);
}
export const getInventoryItem = async (itemId) => {
    return await apiInstance.get(`/inventory/${itemId}`);
}

export const getPublicSale = async () => {
    return await apiInstance.get("/publicsale");
}

export const getSyntheses = async () => {
    return await apiInstance.get("/syntheses");
}

export const getMining = async () => {
    return await apiInstance.get("/mining");
}
export const getDungeons = async () => {
    return await apiInstance.get("/dungeons");
}
export const createSynthesisTransaction = async (data) => {
    return await apiInstance.post("/transactions/synthesis",data);
}
export const createPublicSaleTransaction = async (data) => {
    return await apiInstance.post("/transactions/publicsale",data);
}
export const createPreSaleTransaction = async (data) => {
    return await apiInstance.post("/transactions/presale",data);
};
export const createBuyProductTransaction = async (data) => {
    return await apiInstance.post("/transactions/buyproduct",data);
}
export const createBuySlotTransaction = async (data) => {
    return await apiInstance.post("/transactions/buyslot",data);
}
export const createRechargeTransaction = async () => {
    return await apiInstance.post("/transactions/recharge");
}
export const createUpgradeTransaction = async (data) => {
    return await apiInstance.post("/transactions/upgrade",data);
}
export const createWithdrawTransaction = async (data) => {
    return await apiInstance.post("/transactions/withdraw",data);
}
export const createMarketTransaction = async (data) => {
    return await apiInstance.post("/transactions/market",data);
}
export const updateSlots = async (data) => {
    return await apiInstance.post("/deck/updateslots",data);
}

export const claimAirdrop = async (data) => {
    return await apiInstance.post("/airdrop/claim",data);
}

export const updateDungeon = async (data) => {
    return await apiInstance.post("/dungeons/update",data);
}

export const upgradeCard = async (data) => {
    return await apiInstance.post("/cards/upgrade",data);
}

export const getPowerLeaderboard = async () => {
    return await apiInstance.get("/power/leaderboard");
}
export const getPvpLeaderboard = async () => {
    return await apiInstance.get("/pvp/leaderboard");
}

export const getEnergyItems = async () => {
    return await apiInstance.get("/energy/items");
}

export const addReferrer = async (data) => {
    return await apiInstance.post("/addreferrer",data);
}

export const synthesisCard = async (data) => {
    return await apiInstance.post("/synthesis",data);
}

export const getUserLotteryTickets = async () => {
    return await apiInstance.get("/lottery/tickets");
}
export const getLotteries = async () => {
    return await apiInstance.get("/lottery");
}

export const participateLottery = async (data) =>{
    return await apiInstance.post("/lottery/participate",data);
}

export const claimLottery = async (data) =>{
    return await apiInstance.post("/lottery/claim",data);
}

export const sendJoinRequestToRoulette = async (data) =>{
    return await apiInstance.post("/roulette/join",data);
}

export const rechargeEnergy = async (data) =>{
    return await apiInstance.post("/energy/recharge",data);
}

export const getPvpSeason = async () =>{
    return await apiInstance.get("/pvp/season");
}

export const createCheckOutTransaction = async (data) => {
    return await apiInstance.post("/transactions/checkout",data);
}

export const getOrders = async () => {
    return await apiInstance.get("/orders");
}

export const getNovaPrice = async () => {
    return await apiInstance.get("/price");
}

export const getWithdrawOrders = async () => {
    return await apiInstance.get("/transactions/withdraw");
}

export const getHunterPackAirdrop = async () => {
    return await apiInstance.get("/airdrop/hunterpack");
}